import * as React from "react";

export const useVersionInfo = () => {
  const [showVersionInfo, setShowVersionInfo] = React.useState(false);

  const handleVersionInfo = (e) => {
    if (e.detail === 3) {
      setShowVersionInfo(true);
    }
  };

  return { showVersionInfo, handleVersionInfo, setShowVersionInfo };
};
